import React from "react";
import Header from "./ui/Header";
import NewFooter from "../landingPage/ui/landing_page_new_footer";
import Terms from "./ui/termsandConditionsPage";

export const TermsandConditions = () => {

  return (
    <div className="terms_responsive">
      <Header/>
       <Terms/>
     <NewFooter/>
    </div>
  );
};

